<template>
  <v-list-item link :to="path">
    <v-list-item-content>
      <v-row dense no-gutters class="body-1">
        <v-col cols="4" sm="4" class="d-flex align-center">
          <px-status-negociacao :status-negociacao="resposta.statusNegociacao"/>
          {{ resposta.transportadora.pessoa.nome }}
          <px-popover-transportador :transportador="resposta.transportadora"/>
        </v-col>
        <v-col cols="12" sm="2">
          {{ resposta.prazoEntrega | pluralize(['dia corrido', 'dias corridos']) }}
          <div class="caption">
            Prazo de entrega
          </div>
        </v-col>
        <v-col cols="12" sm="3" class="text-sm-center">
          {{ resposta.valorFrete | currency }}
          <div class="caption">
            Valor sem ICMS
          </div>
        </v-col>
        <v-col cols="12" sm="2" class="text-sm-center">
          <b>{{ resposta.total | currency }}</b>
          <div class="caption">
            Valor do frete
          </div>
        </v-col>
        <v-col cols="12" sm="1" class="text-sm-center">
          <v-btn icon link :to="path">
            <v-icon>
              mdi-eye
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: {
    resposta: Object,
  },
  data() {
    return {
      id: this.$route.params.id,
    };
  },
  computed: {
    path() {
      return `/cotacoes-fretes/${this.id}/respostas/${this.resposta.id}`;
    },
  },
};
</script>
